import { Grid, Tooltip} from "@mui/material";

export function getProductrawtorawdemandStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'You must enter Title',
            required:true,
            fieldtype:'string'
        },
        productrawid:{
            name:'productrawid',
            label:'Product Raw Id',
            value:'',
            error:false,
            errorMessage:'You must enter Product Raw Id',
            required:true,
            fieldtype:'ID'
        },
        rawdemandid:{
            name:'rawdemandid',
            label:'Raw Demand Id',
            value:'',
            error:false,
            errorMessage:'You must enter Raw Demand Id',
            required:true,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:100 },
        { field: 'productrawid', headerName: 'Product Raw Id', width:150 },
        { field: 'rawdemandid', headerName: 'Raw Demand Id', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['productrawid']:{
          ...formValues['productrawid'],
          value:data.productrawid,
        },['rawdemandid']:{
          ...formValues['rawdemandid'],
          value:data.rawdemandid,
        },
      })
}